import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, CanActivateChild, Router } from '@angular/router';
import { isPlatformBrowser } from '@angular/common';
import { LocalStorageService } from 'app/core/storage/local-storage.service';
import { AuthorizationService } from 'app/core/services/authorization/authorization.service';
import { AuthTokenService } from 'app/core/services/auth/auth-token.service';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {
  constructor(
    private router: Router,
    private localStorageService: LocalStorageService,
    @Inject(PLATFORM_ID) private platformId: Object,
    private authorizationService: AuthorizationService,
    private authTokenService: AuthTokenService,
  ) {}

  canActivate(route?: ActivatedRouteSnapshot): boolean {
    // Verifica se está no navegador
    if (isPlatformBrowser(this.platformId)) {

      const token = this.authTokenService.getToken();

      if (token && this.hasPrivilege(route)) {
        return true; // Permite o acesso à rota
      } else {
        
        this.router.navigate(['/login']); // Redireciona para a página de login
        return false; // Bloqueia o acesso à rota
      }
    } else {
      // Se não estiver no navegador, bloqueia o acesso
      return false;
    }
  }

  private hasPrivilege(route?: ActivatedRouteSnapshot): boolean {
    const requiredPrivilege = route?.data?.['requiredPrivilege'] as string | undefined;
    if (!requiredPrivilege || this.authorizationService.can(requiredPrivilege)) {
      return true;
    }

    this.router.navigate(['/page-not-found']);
    return false;
  }
}

@Injectable({ providedIn: 'root' })
export class PrivilegeGuard implements CanActivate, CanActivateChild {
  constructor(
    private router: Router,
    private authorizationService: AuthorizationService,
  ) {}

  canActivate(route: ActivatedRouteSnapshot): boolean {
    return this.check(route);
  }

  canActivateChild(route: ActivatedRouteSnapshot): boolean {
    return this.check(route);
  }

  private check(route: ActivatedRouteSnapshot): boolean {
    const requiredPrivilege = route.data?.['requiredPrivilege'] as string | undefined;
    if (!requiredPrivilege || this.authorizationService.can(requiredPrivilege)) {
      return true;
    }

    this.router.navigate(['/page-not-found']);
    return false;
  }
}
